var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg148OpenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460,362c11.046,0,20-8.954,20-20v-74c0-44.112-35.888-80-80-80H175.963v-70.534c0-42.715,35.888-77.466,80-77.466 s80,34.991,80,78c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20c0-65.065-53.832-118-120-118s-120,52.695-120,117.466V188H112 c-44.112,0-80,35.888-80,80v164c0,44.112,35.888,80,80,80h288c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40H112c-22.056,0-40-17.944-40-40V268c0-22.056,17.944-40,40-40h288 c22.056,0,40,17.944,40,40v74C440,353.046,448.954,362,460,362z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 347,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg148OpenLock);
export default __webpack_public_path__ + "static/media/148-open-lock.42a8e4c88f22fac8939f2e3ef9f0e155.svg";
export { ForwardRef as ReactComponent };